/**
 * Whether Visualisation chart artifacts can be drawn.
 *
 * They cannot yet: a dashboard run returns only the artifact's preview rows
 * (analytics `DashboardExecutionService`) and the chart widget has no bar, line or table
 * renderer. Until SF-109 draws them, the product offers no new charts (Visualisation Studio
 * builder) and no new chart widgets, and saved chart widgets say plainly that they cannot be
 * drawn. Saved charts and widgets stay readable, savable and runnable.
 */
export const CHART_RENDERING_AVAILABLE = false;

/** What a saved chart widget says while charts cannot be drawn, before and after a run. */
export const CHART_UNAVAILABLE_MESSAGE =
  "This chart can't be shown on dashboards yet. Its settings are kept, and it will appear here when chart drawing is available.";
